<template>
  <el-submenu
    v-if="!node.hidden && hasChildren && !isSingleLeafChild"
    :index="submenuIndex"
  >
    <template slot="title">
      <i v-if="iconClass" :class="iconClass"></i>
      <span slot="title">{{ menuName }}</span>
    </template>
    <sidebar-menu-item
      v-for="(child, index) in children"
      :key="menuKey(child, index)"
      :item="child"
    />
  </el-submenu>
  <el-menu-item v-else-if="!node.hidden && isNavigable" :index="menuItemPath">
    <i v-if="menuItemIcon" :class="menuItemIcon"></i>
    <span slot="title">{{ menuName }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: "SidebarMenuItem",
  props: {
    item: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    node() {
      return this.item && typeof this.item === "object" ? this.item : {};
    },
    children() {
      return Array.isArray(this.node.children)
        ? this.node.children.filter((child) => child && typeof child === "object")
        : [];
    },
    hasChildren() {
      return this.children.length > 0;
    },
    isSingleLeafChild() {
      return (
        this.children.length === 1 &&
        !this.hasChildrenFor(this.children[0]) &&
        this.isValidMenuPath(this.children[0] && this.children[0].path)
      );
    },
    isNavigable() {
      return (
        this.isSingleLeafChild ||
        (!this.hasChildren && this.isValidMenuPath(this.node.path))
      );
    },
    menuName() {
      return this.textFor(this.node.name, "未命名菜单");
    },
    iconClass() {
      return this.textFor(this.node.icon || this.node.iconCls, "");
    },
    submenuIndex() {
      const menuId = this.node.menuId;
      return menuId === undefined || menuId === null || menuId === ""
        ? "menu-" + this._uid
        : "menu-" + String(menuId);
    },
    menuItemPath() {
      const destination = this.isSingleLeafChild
        ? this.children[0]
        : this.node;
      return this.pathFor(destination);
    },
    menuItemIcon() {
      // Keep the existing single-child presentation: only the parent title is shown.
      return this.isSingleLeafChild ? "" : this.iconClass;
    }
  },
  methods: {
    hasChildrenFor(node) {
      return (
        node &&
        Array.isArray(node.children) &&
        node.children.some((child) => child && typeof child === "object")
      );
    },
    pathFor(node) {
      const path = node && node.path;
      return this.isValidMenuPath(path) ? path : "";
    },
    isValidMenuPath(path) {
      return typeof path === "string" && path && path !== "/Layout";
    },
    textFor(value, fallback) {
      return typeof value === "string" && value ? value : fallback;
    },
    menuKey(node, index) {
      if (node && node.menuId !== undefined && node.menuId !== null) {
        return "menu-" + String(node.menuId);
      }
      return this.pathFor(node) + "-" + index;
    }
  }
};
</script>
